export default __webpack_public_path__ + "static/media/banner.04863855.png";